import { render, staticRenderFns } from "./UpcomingCommunications.vue?vue&type=template&id=4d7d72f6&scoped=true&"
import script from "./UpcomingCommunications.vue?vue&type=script&lang=ts&"
export * from "./UpcomingCommunications.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingCommunications.vue?vue&type=style&index=0&id=4d7d72f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d72f6",
  null
  
)

export default component.exports